module.exports = __webpack_public_path__ + "static/React-Iphone-Still-f8af26493e6baeb2384cfeb086defb67.jpg";